<template>
  <v-row no-gutters>
    <v-col cols="12" md="12" xl="1" class="text-body-2 text-lg-body-2 mt-1">
      <div>{{ txt }}</div>
    </v-col>
    <v-radio-group
      :row="true ? $vuetify.breakpoint.mdAndUp : false"
      :cols="true ? $vuetify.breakpoint.smAndDown : false"
      v-model="radioModal"
      class="mt-0"
      dense
    >
      <v-radio value="1" color="#006CA1">
        <template v-slot:label>
          <span class="text-body-2 text-lg-body-2 font-weight-regular">
            {{ labelOne }}
          </span>
        </template>
      </v-radio>
      <v-radio value="2" color="#006CA1">
        <template v-slot:label>
          <span class="text-body-2 text-lg-body-2 font-weight-regular">
            {{ labelTwo }}
            <!-- For the csr -->
            <slot name="csr"></slot>
          </span>
        </template>
      </v-radio>
    </v-radio-group>
  </v-row>
</template>
<script>
export default {
  props: ["txt", "radioGroup", "labelOne", "labelTwo"],
  computed: {
    radioModal: {
      get: function () {
        return this.radioGroup;
      },
      set: function (newVal) {
        this.$emit("update:radioGroup", newVal);
      },
    },
  },
};
</script>
ss

<style></style>
